module.exports = "/lucky-balls/img/infobox/info_Box_017.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_017.png
// module id = 1082
// module chunks = 0